module.exports = __webpack_public_path__ + "static/media/vencimiento_rojo.da80ae37.svg";